import { LOCALES } from '../locales';

const fr =  {
    [LOCALES.FRENCH]: {
        //Navbar
        'navbar.ami': "AMI",
        'navbar.accueil': "Accueil",
        'navbar.commencer': "Commencer",
        'navbar.strategie': "Mes stratégies",
        'navbar.deconnection': "Se déconnecter",
        'navbar.capsule': "Capsules",
        'navbar.contact': "Contactez-nous",
        //Accueil
        'accueil.ami_into_titre': "Mise en garde et informations importantes concernant l’application AMI – Aide mémoire d’intervention",
        'accueil.ami_intro_1': "Cette application a été conçue pour vous soutenir face aux difficultés que vous pouvez rencontrer avec votre proche ou un usager avec lequel vous intervenez ayant une perte d’autonomie cognitive. Elle a pour but de vous offrir des pistes en fonction de la source de la difficulté pouvant se manifester dans la vie quotidienne.",
        'accueil.ami_intro_2': "Il est possible que certaines pistes soient plus difficiles à appliquer dans certaines situations complexes et particulières, entre autres, en raison de la présentation et de la combinaison des déficits cognitifs, très variables d’une personne à l’autre. Si les pistes conseillées s’avèrent inefficaces, que vous sentez que ça vous demande trop d’efforts ou que les difficultés nuisent à la relation avec votre proche, n’hésitez pas à vous référer à un ergothérapeute ou un autre intervenant qui pourra vous aider et vous accompagner dans l’application des stratégies au quotidien.",
        'accueil.ami_intro_3.1': "Par la création d’un profil utilisateur, ",
        'accueil.ami_intro_3.2': "l’utilisateur de l’application obtient la permission de consulter et d’utiliser l’outil, pour ses fins personnelles et sur une base individuelle seulement",
        'accueil.ami_intro_3.3': ". L’utilisateur de l’application n’est pas autorisé à divulguer son mot de passe ou rendre disponible, de toute autre manière, l’application et son contenu à quiconque, chaque utilisateur de l’application devant s’inscrire individuellement sur l’application pour accéder à son contenu",
        'accueil.ami_intro_4.1': "Tous droits réservés",
        'accueil.ami_intro_4.2': ". Aucune partie du contenu de l’application, incluant les capsules, ne peut être reproduite ni partagée, sous quelque forme ou par quelque procédé que ce soit, sans ",
        'accueil.ami_intro_4.3': "l’autorisation préalable écrite du Laboratoire d’optimisation cognitive de l’Université de Sherbrooke (LOPCUS)",
        'accueil.ami_intro_4.4': ", ou dans la mesure permise par la loi. Toute demande de renseignements concernant une reproduction doit être transmise à l’adresse ci-dessous :",
        
        'accueil.ami_intro_5.1': "Laboratoire d’optimisation cognitive de l’Université de Sherbrooke (LOPCUS)",
        'accueil.ami_intro_5.2': "Faculté de médecine et des sciences de la santé",
        'accueil.ami_intro_5.3': "Université de Sherbrooke",
        'accueil.ami_intro_5.4': "3001, 12e Ave N.",
        'accueil.ami_intro_5.5': "Sherbrooke (Québec) J1H 5H3",
        'accueil.ami_intro_5.6': "À l’attention de Pre Chantal Viscogliosi",
        'accueil.ami_intro_5.7': "Courriel: Chantal.Viscogliosi@usherbrooke.ca",
        
        'accueil.ami_intro_6': "L’application n’est pas conçue pour être utilisée sans indications préalables. Il est donc suggéré d’avoir suivi une formation avant son utilisation.",
        'accueil.ami_intro_7': "L’Université de Sherbrooke et les auteurs de l’application :",
        'accueil.ami_intro_8': "ne font aucune représentation, et n’offrent aucune garantie ou indemnité, quant à l’exactitude, la validité ou le caractère exhaustif du contenu de l’application;",
        'accueil.ami_intro_9': "n’assument aucune responsabilité découlant ou pouvant découler de l’utilisation, de l’application ou de l’interprétation de l’application et de son contenu par toute personne.",

        'accueil.ami_texte': "Aide- Mémoire-Interactif (AMI)",
        'accueil.ami_description': "Cette application a été conçue pour vous soutenir face aux difficultés que vous pouvez rencontrer avec votre proche ayant une perte d’autonomie cognitive. Elle a pour but de vous offrir des pistes en fonction de la source de la difficulté pouvant se manifester dans la vie quotidienne.",
        'accueil.piste_description': "Il est possible que certaines pistes soient plus difficiles à appliquer dans certaines situations complexes et particulières, entre autres, en raison de la présentation et de la combinaison des déficits cognitifs, très variables d’une personne à l’autre. Si les pistes conseillées s’avèrent inefficaces, que vous sentez que ça vous demande trop d’efforts ou que les difficultés nuisent à la relation avec votre proche, n’hésitez pas à vous référer à un ergothérapeute, qui pourra vous aider et vous accompagner dans l’application des stratégies au quotidien.",
        'accueil.collab': "Collaboration",
        'accueil.responsable_lopcus': "Responsable du laboratoire d'optimisation cognitive de l'Université de Sherbrooke (LOPCUS)",
        'accueil.societe_mask': "Société Alzheimer des Maskoutains-Vallée des Patriotes: Partenaire pour le développement de l'application",
        'accueil.domus_chercheurs': "Chercheurs au laboratoire de recherche en domitique et informatique mobile (DOMUS)",
        'accueil.etudiant_genie': "Étudiants en génie informatique",
        'accueil.etudiant_ergo': "Étudiants en ergothérapie",
        'accueil.ergo': "Ergothérapeutes",
        'accueil.linguistique': "Révision linguistique",
        'accueil.graphisme': "Grahisme",
        'accueil.partenaires': "Nos partenaires",
        'accueil.traduction': "Traducteurs",
        // Contact
        "contact.envoyer_commentaire": "Envoyer-nous vos commentaires",
        "contact.nom_fmss": "Faculté de médecine et des sciences de la santé de l’Université de Sherbrooke",
        "contact.adresse_ami": "3001 12 Ave N, Sherbrooke, Quebec J1H 5H3",
        "contact.telephone_ami": "Téléphone : (819) 821-8000 ext. 72934",
        "contact.email_ami": "Chantal.Viscogliosi@USherbrooke.ca",
        "contact.votre_email": "Votre adresse courriel:",
        "contact.votre_nom": "Votre nom:",
        "contact.votre_commentaire": "Votre commentaire:",
        "contact.envoyer": "Envoyer",
        //Questionnaire
        "questionnaire.historique": "Historique",
        "questionnaire.questionnaire_ami": "Questionnaire AMI",
        "questionnaire.app_prealable": "L’application n’est pas conçue pour être utilisée sans indications préalables, il est donc suggéré d’avoir suivi une formation avant son utilisation.",
        "questionnaire.commencer": "Commencer",
        "questionnaire.choix_strategie": "Choix strategie",
        "questionnaire.nouv_strategie": "Nouvelle strategie",
        "questionnaire.strategie_titre": "Strategie:",
        "questionnaire.creer_strategie": "Créer une stratégie:",
        "questionnaire.modifier_strategie": "Modifier une stratégie:",
        "questionnaire.chemin": "Est-ce que le chemin a fonctionné?",
        "questionnaire.oui": "Oui",
        "questionnaire.non": "Non",
        "questionnaire.resumer_strategie": 'Pour avoir un résumé des dernières stratégies que vous avez essayées en fonction de vos situations quotidiennes, consulter la section "Mes strategies"',
        "questionnaire.piste_action": "Pistes d'action pour favoriser l'apprentissage dans la vie quotidienne.",
        "questionnaire.ajouter_info": "Ajouter un plus d'information",
        "questionnaire.choix_info": "Choix plus d'information",
        "questionnaire.nouv_info": "Nouveau plus d'information",
        "questionnaire.info_sup": "Informations supplémentaires possibles:",
        "questionnaire.titre": "Titre:",
        "questionnaire.lien_video": "Lien vers vidéo:",
        "questionnaire.effacer_tout": "Tout effacer",
        "questionnaire.creer": "Créer",
        "questionnaire.id": "Identifiant",
        "questionnaire.duree": "Durée (minutes)",
        "questionnaire.debut": "Temps début",
        "questionnaire.fin": "Temps fin",
        "questionnaire.supprimer": "Supprimer la selection",
        "questionnaire.status": "Status:",
        "questionnaire.choix": "Choix question",
        "questionnaire.nouvelle_question": "nouvelle question",
        "questionnaire.modifier_question": "Modifier la question sélectionnée:",
        "questionnaire.creer_question": "Créer une question:",
        "questionnaire.supprimer_element": "Êtes-vous certain de vouloir supprimer cet élément ?",
        "questionnaire.dupliquer_element": "Êtes-vous certain de vouloir dupliquer cet élément ?",
        "questionnaire.AjouterReponse": "Ajouter réponse",
        "questionnaire.AjouterQuestion": "Ajouter question",
        "questionnaire.AjouterStrategie": "Ajouter stratégie",
        "questionnaire.fonctionne": "A fonctionné",
        "questionnaire.non_fonctionne": "N'a pas fonctionné",
        "questionnaire.recommencer": "Recommencer",
        "questionnaire.retour": "Retour",
        "questionnaire.confirmer": "Confirmer",
        "questionnaire.annuler": "Annuler",
        "questionnaire.autreTitle": "Réponse personnalisée",
        "questionnaire.autreDescription": "Veuillez entrer votre réponse",

        //Capsule
        "capsule.non_disponible": "Capsule non-disponible",

        //Historique
        "historique.titre": "Historique des stratégies",
        "historique.fonctionne": "A fonctionné",
        "historique.non_fonctionne": "N'a pas fonctionné",
        "historique.recent": "Récents",
        "historique.favoris": "Favoris",
        "historique.voirStrategie": "Voir strategie",
        "historique.retourStrategie": "Revenir à l'historique des stratégies",
        "dialog.restart_title": "Êtes-vous certain de vouloir recommencer le questionnaire ?",
        "dialog.yes": "Oui",
        "dialog.no": "Non",
        "questionnaire.autrePlaceholder": "Entrer votre réponse",

    }
}

export default fr;

